import Vue from 'vue'
import Vuetify from 'vuetify'
import App from './App.vue'
import router from './router'
import { store } from './store/store'
import * as types from './store/types'
import { colors } from './config.js'
import { API_URL, CKEY } from './config'
import Pusher from 'pusher-js'
import { filters } from './plugins/core/dd.filters.js'
import notify from './plugins/core/dd.notify'
import permission from './plugins/core/dd.permission'
import 'vuetify/dist/vuetify.min.css'
import 'vuetify/src/stylus/app.styl'
import './styles/default.styl'
import './assets/main.css'
import './assets/map-icons.css'
import { initPusher } from './plugins/core/dd.pusher'
import Toasted from 'vue-toasted';
//import('vue2-animate/dist/vue2-animate.min.css')
 
import('animate.css')

/*
import { library } from '@fortawesome/fontawesome-svg-core'
import faGasPump from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add({faGasPump})
Vue.component('font-awesome-icon', FontAwesomeIcon)
*/

Vue.use(Toasted,{iconPack:'fontawesome'})
Vue.use(require('vue-chat-scroll'))

initPusher()

Vue.config.productionTip = false



router.beforeEach((to, from, next) => {

  if(to.path.toLowerCase() == "/login" || to.name == "Login" || to.path.toLowerCase() == "/reset-password" || to.name == "ResetPassword"  )
  {
    next();
  }
  else if(!store.getters[types.IS_AUTHENTICATED]) {  
      next('Login');
  }
  else {
    // no permission set give access
    if(!to.meta || !to.meta.permission )
      next()
    
    if(Vue.prototype.$currentUserHasPermission(to.meta.permission))    
      next();
    else{
      Vue.prototype.$notify("Je hebt geen rechten om deze pagina te opnenen")
    }
  }
})

if(!store.getters[types.USER_LANGUAGE]){
  store.commit(types.USER_LANGUAGE, store.getters[types.LANGUAGES][0])
}

Vue.use(Vuetify, {
    theme: {
      ...colors
    },
    customProperties: true,
    
  });

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
